import { ViewChild } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { SelectComponent } from 'ng2-select';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { AdminPortalDatePickerModes } from '../../../shared/components/admin-portal-date-picker/admin-portal-date-picker.component';
import { APIOperableComponent } from '../../../shared/components/api-operable/api-operable.component';
import { ProductSelectorDialogComponent } from '../../../shared/components/product-selector-dialog/product-selector-dialog.component';
import { NgSelectOptionModel } from '../../../shared/model/ng-select-option.model';
import { UIDialogService } from '../../../shared/services/ui-dialog.service';
import { RequestUrlUtils } from '../../../shared/utils/request.url.utils';
import { SortUtils } from '../../../shared/utils/sort.utils';
import { ProductUIMessages } from '../../product/model/product-ui.messages';
import { ProductService } from '../../product/service/product.service';
import { AuthService } from '../../security/service/auth.service';
import { AssetService, STARBUCKS_SITE_ID } from '../service/asset.service';
import { AssetAttachmentModel } from './model/asset-attachment.model';
import { AssetSearchModel } from './model/asset-search.model';
import { AssetUIMessages } from './model/asset-ui.messages';
import { AssetModel } from './model/asset.model';
import { SiteSelectorDialogComponent } from './site-selector/site-selector-dialog.component';

export abstract class AssetBaseComponent extends APIOperableComponent {
  @ViewChild('customerSelect', { static: true })
  protected customerSelect: SelectComponent;
  protected assetId: number;
  protected selectedCustomer: NgSelectOptionModel;
  protected assetModel: AssetModel = new AssetModel();
  protected operations: any = {
    loading: true,
    linesOfService: {
      loading: true
    },
    attachments: {
      loading: true
    }
  };
  protected linkedLOS: Array<{ id: string; value: string }> = [];
  // protected allSites: Array<{id: string, text: string}> = [];
  protected allCustomers: Array<{ id: string; text: string }> = [];
  protected assetAttachments: Array<AssetAttachmentModel> = [];
  public static readonly STARBUCKS_MAKE_MODEL_LIST: Array<string> = [
    'Bonmac / HIKARI SIPHON BAR HST-103',
    'Bunn / DUAL SH',
    'Bunn / SINGLE SH',
    'Cirqua / 300N',
    'Cirqua / A SERIES',
    'Cirqua / HP800',
    'Cirqua / LP500',
    'Clover / CLOVER 1S',
    'Ditting / KFR1203',
    'Ditting / KR1203',
    'Ditting / KR804',
    'Everpure / CSR Hi-Flow Triple',
    'Everpure / CSR Hi-Flow Quad',
    'Everpure / MRS-400',
    'Everpure / MRS-600HE',
    'Everpure / MRS-600HE-II',
    'Eversoft / Exchange Tank',
    'Fleck / 5100',
    'Fleck / 5600',
    'Fleck / TWINFLO-100',
    'Fleck / TWINFLO-9100',
    'Grindmaster / 875',
    'Grindmaster / 890',
    'Mahlkonig / GUATEMALA LAB',
    'Marco / ECOBOILER 10L',
    'Modbar / ESPRESSO SYSTEM',
    'Modbar / POUR OVER SYSTEM',
    'Modbar / STEAM SYSTEM',
    'Multiplex / ND21',
    'Nimbus / A3-00',
    'Nimbus / R-1500',
    'Nuova Simonelli / AURELIA II -  2 Group',
    'Nuova Simonelli / AURELIA II -  3 Group',
    'Nuova Simonelli / AURELIA II -  4 Group',
    'Nuova Simonelli / BLACK EAGLE VA388 T3 - 2 Group',
    'Nuova Simonelli / BLACK EAGLE VA388 T3 - 3 Group',
    'Nuova Simonelli / MYTHOS ONE CLIMA PRO',
    'Nuova Simonelli / WHITE EAGLE VA358 - 2 Group',
    'Nuova Simonelli / WHITE EAGLE VA358 - 3 Group',
    'SpectraPure / CLS1000',
    'SpectraPure / PSP',
    'Thermoplan / MASTRENA CTS2',
    'Thermoplan / MASTRENA II',
    'Thermoplan / VERISMO CTS',
    'Water Heater / WATER HEATER',
    'Vitamix / Spray Park',
    'Multiplex / Tap Handle',
    'Rhino Coffee Gear / Spinjet',
    'Multiplex / SC180'
  ];
  private static readonly STARBUCKS_MAKE_MODEL_MASKS: any = {
    'Bunn / DUAL SH': {
      array: ['D', 'U', 'A', 'L', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
      regexp: 'DUAL\\d{7}'
    },
    'Bunn / SINGLE SH': {
      array: ['S', 'N', 'G', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
      regexp: 'SNG\\d{7}'
    },
    'Clover / CLOVER 1S': {
      array: [/\d/, /\d/, /\d/, '?', /\d/],
      regexp: '\\d{3}?\\d'
    },
    'Thermoplan / VERISMO CTS': {
      array: [
        /\d/,
        /\d/,
        '/',
        /\d/,
        '/',
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ],
      regexp: '\\d{2}/\\d/\\d{2}-\\d{4}'
    },
    'Thermoplan / MASTRENA CTS2':
      '' /* Need to be either 40-999999 or 999999, Can't do it with the mask*/,
    'Ditting / KR1203': {
      array: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '?', /\d/, /\d/, /\d/, /\d/],
      regexp: '\\d{6}?\\d{4}'
    },
    'Ditting / KFR1203': {
      array: [/\d/, /\d/, /\d/, /\d/, /\d/],
      regexp: '\\d{5}'
    },
    'Ditting / KR804': {
      array: [/\d/, /\d/, /\d/, /\d/, /\d/],
      regexp: '\\d{5}'
    },
    'Grindmaster / 875': {
      array: [
        'L',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ],
      regexp: 'L\\d{6}-\\d{4}'
    },
    'Grindmaster / 890': {
      array: [
        'L',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ],
      regexp: 'L\\d{6}-\\d{4}'
    },
    'Cirqua / 300N': {
      array: ['3', '0', '0', 'N', /\d/, /\d/, /\d/, /\d/, /\d/],
      regexp: '300N\\d{5}'
    },
    'Cirqua / HP800': {
      array: ['8', '0', '0', 'T', '0', /\d/, /\d/, /\d/, /\d/, /\d/],
      regexp: '800T0\\d{5}'
    }
  };
  protected serialNumberMask: any = { array: false };
  protected DATEPICKER_MODES = AdminPortalDatePickerModes;
  subtypeAssetAttachments: AssetAttachmentModel[];
  subtypeMfgPlateAttachments: AssetAttachmentModel[];
  private readonly AssetAttachmentSubtype: string = 'asset';
  private readonly MfgPlateAttachmentSubtype: string = 'mfgPlate';

  constructor(
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    protected assetService: AssetService,
    protected productService: ProductService,
    protected dialogService: UIDialogService
  ) {
    super(progressService, toastr, authService);
  }

  /**
   * Loads a list of customers
   * @returns {Observable<any>}
   */
  protected loadCustomers(): Observable<any> {
    let subject = new Subject<any>();
    this.progressRef.start();
    this.assetService.getCustomers().subscribe(
      (res: any) => {
        if (res) {
          let customers = res.map(customer => {
            return {
              id: customer.number,
              text: `${customer.name} (${customer.number})`
            };
          });
          this.allCustomers = customers.sort((a, b) =>
            SortUtils.compareByProperty(a, b, 'text')
          );
        }
        subject.next(this.allCustomers);
      },
      () => this.onAPIError(AssetUIMessages.LOAD_CUSTOMERS_ERROR)
    );
    return subject.asObservable();
  }

  /**
   * Loads the linked lines of service, based on the productID from the asset.
   */
  protected loadLinkedLinesOfService(): void {
    this.operations.linesOfService.loading = true;
    this.productService.getLOSProductById(this.assetModel.productId).subscribe(
      (res: any) => {
        this.linkedLOS = RequestUrlUtils.mapCollection(
          res.results,
          'name',
          'value'
        );
        this.operations.linesOfService.loading = false;
      },
      () => this.onAPIError(ProductUIMessages.LOAD_LINES_OF_SERVICE_ERROR)
    );
  }

  /**
   * Loads the attachments of a given assetId.
   */
  protected loadAssetAttachments(): void {
    this.operations.attachments.loading = true;
    this.assetService.getAssetAttachments(this.assetModel.id).subscribe(
      (res: Array<AssetAttachmentModel>) => {
        this.assetAttachments = res;
        this.subtypeMfgPlateAttachments = this.assetAttachments.filter(
          item => item.subType === this.MfgPlateAttachmentSubtype
        );
        this.subtypeAssetAttachments = this.assetAttachments.filter(
          item => item.subType === this.AssetAttachmentSubtype
        );

        this.operations.attachments.loading = false;
      },
      () => this.onAPIError(ProductUIMessages.LOAD_ASSET_ATTACHMENT_ERROR)
    );
  }

  /**
   *  Adds the site id to the Filter Module.
   * @param site
   */
  protected onSelectSite(site: any): void {
    if (site) {
      this.assetModel.siteId = site.id;
      this.checkForStarbucks();
      this.onSiteChange();
    }
  }

  /**
   * Checks if Starbucks site is selected.
   * If true sets the specific set of masks for serial number input.
   */
  protected checkForStarbucks(): void {
    if (this.isStarbucksSiteSelected()) {
      this.setStarbucksSerialNumberMask();
    } else {
      this.serialNumberMask = { array: false };
    }
  }

  /**
   * Sets the special set of Masks for Serial Number input.
   */
  private setStarbucksSerialNumberMask(): void {
    const makeModelText =
      (this.assetModel.make ? this.assetModel.make.name : '') +
      ' / ' +
      (this.assetModel.product ? this.assetModel.product.model : '');
    this.serialNumberMask = this.getStarbucksMaskForMakeModel(makeModelText);
  }

  /**
   * On Product Edit click event.
   */
  protected onProductEdit(): void {
    this.dialogService
      .open(ProductSelectorDialogComponent, [
        { provide: 'product', useValue: this.assetModel.product },
        {
          provide: 'isStarbucksSite',
          useValue: this.isStarbucksSiteSelected()
        },
        { provide: 'assets', useValue: null },
        { provide: 'customization', useValue: { title: 'My Title' } }
      ])
      .then(result => {
        if (result.product && result.product.id) {
          this.assetModel.product = result.product;
          this.assetModel.productId = result.product.id;
          this.assetModel.make = result.make;
          this.checkForStarbucks();
          this.onProductChange();
        }
      })
      .catch(err => {
        // On Cancel Close
      });
  }

  /**
   * On Site Edit click event.
   */
  protected onSiteEdit(): void {
    this.dialogService
      .open(SiteSelectorDialogComponent, [
        { provide: 'site', useValue: this.assetModel.site },
        { provide: 'selectedCustomer', useValue: this.selectedCustomer }
      ])
      .then(result => {
        if (result.site && result.site.id) {
          this.assetModel.site = result.site;
          this.assetModel.siteId = result.site.id;
          this.selectedCustomer = result.customer;
          this.checkForStarbucks();
        }
      })
      .catch(err => {
        // On Cancel Close
      });
  }

  /**
   * Validates that serial number doesn't exists already on the asset list.
   * @param {string} serialNumber
   * @param {string} make
   * @param {number} assetId
   * @returns {Promise<any>}
   */
  protected validateUniqueSerialNumberPromise(
    serialNumber: string,
    siteId: string,
    assetId?: number
  ): Promise<any> {
    if (!assetId) {
      assetId = -1;
    }
    const promise = new Promise((resolve, reject) => {
      let searchModel: AssetSearchModel = new AssetSearchModel();
      searchModel.filterModel.serialNumber = serialNumber;
      searchModel.filterModel.siteId = siteId;
      searchModel.filterModel.showInactive = true;
      this.assetService.searchAssets(searchModel).subscribe(
        (response: any) => {
          if (
            response != null &&
            response.results != null &&
            response.results.length > 0
          ) {
            response.results.forEach(asset => {
              if (
                asset.serialNumber === serialNumber &&
                asset.id.toString() !== assetId.toString()
              ) {
                reject(AssetUIMessages.SERIAL_NUMBER_INVALID);
              }
            });
          }
          resolve(true);
        },
        err => {
          this.onAPIError(AssetUIMessages.SERIAL_NUMBER_ERROR);
          reject(AssetUIMessages.SERIAL_NUMBER_ERROR);
        }
      );
    });
    return promise;
  }

  /**
   * Validates if site is Starbucks.
   */
  protected isStarbucksSiteSelected(): boolean {
    return STARBUCKS_SITE_ID === this.assetModel.siteId;
  }

  protected getStarbucksMaskForMakeModel(makeModelText: string): any {
    return AssetBaseComponent.STARBUCKS_MAKE_MODEL_MASKS[makeModelText]
      ? AssetBaseComponent.STARBUCKS_MAKE_MODEL_MASKS[makeModelText]
      : {
          array: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
          regexp: '\\d{2}-\\d{6}'
        };
  }

  protected validSerialNumber(): boolean {
    let invalidSerialNumber = false;
    if (this.isStarbucksSiteSelected()) {
      let regex = new RegExp('^' + this.serialNumberMask.regexp + '$');
      invalidSerialNumber = !regex.test(this.assetModel.serialNumber);
    }
    return invalidSerialNumber;
  }
  // validate asset tag input typed in number only.
  protected validAssetTag(): boolean {
    let invalidAssetTag = false;
    if (this.assetModel.tag.length !== 0) {
      let regex = new RegExp('^[0-9]+$');
      invalidAssetTag = !regex.test(this.assetModel.tag);
    }
    return invalidAssetTag;
  }

  // validate asset location characters
  protected validAssetLocation(assetLocation: string): boolean {
    let regex = new RegExp(/[/\a-zA-Z0-9 ,.-]/);
    return regex.test(assetLocation);
  }

  // validate special characters for assetlocation on copy paste

  protected validateAssetLocationOnCopyPaste(assetLocation: string): boolean {
    let regex = new RegExp(/[^a-zA-Z0-9 ,.-]/);
    return regex.test(assetLocation);
  }

  /* Validate Outer Spaces for AssetLocation*/

  removeTrailingSpacesForAssetLocation(assetLocation: string): string {
    assetLocation = assetLocation.trim();
    return (assetLocation = assetLocation.length == 0 ? null : assetLocation);
  }

  protected canManageAssets(): boolean {
    return this.authService.isAssetManager() || this.authService.isAdmin();
  }

  /**
   * Meant to be override if needed by child components.
   */
  protected onSiteChange(): void {
    // Silence is golden
  }

  /**
   * Meant to be override if needed by child components.
   */
  protected onProductChange(): void {
    // Silence is golden
  }

  protected invalidForm(): boolean {
    return !this.assetModel.productId || !this.assetModel.siteId;
  }
}
